@if (hotelStaticInfo) {
  @if (isMobile) {
    <hotel-detail-mobile
      [isLanding]="isLanding"
      [searchedEntity]="searchedEntity"
      [hotelStaticInfo]="hotelStaticInfo"
      (resetState)="resetState($event)"
      [busy]="busy"
      [accommodationFee]="accommodationFee"
      [recommendedHotels]="recommendedHotels"
      [error]="!!hotelAvailabilityInfo?.error"
      [emptyStateCode]="error?.error.code"
    ></hotel-detail-mobile>
  } @else {
    <hotel-detail
      [isLanding]="isLanding"
      [searchedEntity]="searchedEntity"
      (resetState)="resetState($event)"
      [busy]="busy"
      [accommodationFee]="accommodationFee"
      [recommendedHotels]="recommendedHotels"
      [error]="error"
    ></hotel-detail>
  }
} @else {
  <div class="loading"></div>
}
